import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("GPP_User_Data")));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const phone = params.get("Phonenumber");

    if (phone && !user) {
      const loginViaPhone = async () => {
        try {
          const res = await fetch(
            `https://apiv2.mobileartsme.com/LoginWithoutPass?MSISDN=${phone}&IDService=8`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
            }
          );

          const data = await res.json();

          if (data.Error === 0 && data.Result.Status === 0) {
            const result = { ...data.Result, Phone: phone };
            localStorage.setItem("GPP_User_Data", JSON.stringify(result));
            setUser(result);
          } else {
            alert(data.Result?.Description || "Login failed");
          }
        } catch (error) {
          alert("Something went wrong during login");
          console.error(error);
        } finally {
          setChecking(false);
        }
      };

      loginViaPhone();
    } else {
      setChecking(false);
    }
  }, [location.search, user]);

  if (checking) return null; // Optionally return a spinner or loading state

  const isPublicPath = location.pathname === "/" || location.pathname === "/games";
  const isDashboardPath = location.pathname.startsWith("/dashboard");

  if (user && isPublicPath) {
    return <Navigate to="/dashboard/home" replace />;
  }

  if (!user && isDashboardPath) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;
